
<template>
  <div id="page-data-view">

      <vx-card title="User Details" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <!-- reading docs -->
              <img :src="files[0]" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ view_data.email }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Is Activated</td>
                <td>{{ view_data.is_activated }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Notes</td>
                <td>{{ view_data.notes }}</td>
              </tr>
              <tr>
                <td class="font-semibold">User Role</td>
                <!-- <td v-if="view_data.user_role !== null">{{ view_data.user_role.name }}</td> -->
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->

          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-user-edit', params: { editId: $route.params.viewId }}" 
            :disabled="!showU">Edit <!-- crud -->
            </vs-button> 
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord" 
            :disabled="!showD">Delete <!-- crud -->
            </vs-button>
          </div>

        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Personal Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Salutation</td>
                <!-- <td v-if="view_data.salutation !== null">{{ view_data.salutation.name }}</td> -->
              </tr>
              <tr>
                <td class="font-semibold">First Name</td>
                <!-- <td>{{ view_data.first_name }}</td> -->
              </tr>
              <tr>
                <td class="font-semibold">Last Name</td>
                <!-- <td>{{ view_data.last_name }}</td> -->
              </tr>
              <tr>
                <td class="font-semibold">Suffix</td>
                <td>{{ view_data.suffix }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Phone 1</td>
                <td>{{ view_data.phone1 }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Phone 2</td>
                <td>{{ view_data.phone2 }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Date of Birth</td>
                <td>{{ view_data.dob }}</td>
              </tr>
            </table>
          </vx-card>
        </div> 

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Address" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Address Line 1</td>
                <td>{{ view_data.address_line_1 }}</td>
              </tr> 
              <tr>
                <td class="font-semibold">Address Line 2</td>
                <td>{{ view_data.address_line_2 }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Province</td>
                <td>{{ view_data.province }}</td>
              </tr>
              <tr>
                <td class="font-semibold">City</td>
                <td>{{ view_data.city }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Country</td>
                <!-- <td v-if="view_data.country_master !== null">{{ view_data.country_master.name }}</td> -->
              </tr>
              <tr>
                <td class="font-semibold">Postcode</td>
                <td>{{ view_data.postcode }}</td>
              </tr>
            </table>
          </vx-card>
        </div> 
        
      </div>     

    <vs-alert color="danger" title="Data Not Found" :active.sync="data_not_found">
      <span>Data record with id: {{ $route.params.viewId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'app-user-list'}" class="text-inherit underline">All Data</router-link>
      </span>
    </vs-alert>

    <div v-if="access_level >= 99">
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Property Manager Assigned" class="mb-base">
            <PropertyManagerList></PropertyManagerList>
          </vx-card>
        </div>
        
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Property User Assigned" class="mb-base">
            <PropertyUserList></PropertyUserList>
          </vx-card>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud
import PropertyManagerList from './property-manager/list/List.vue'
import PropertyUserList from './property-user/list/List.vue'

export default {
  components: {
    PropertyManagerList,
    PropertyUserList
  },
  data () {
    const token = localStorage.usertoken
    return {
      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,

      access_level: 0,

      token: token,
      
      //user
      view_data: {
        email: '',
        first_name: '',
        last_name: '',
        is_activated: '',
        password: '',
        profile_json: '',
        phone1: '',
        dob: '',
        middle_name: '',
        phone2: '',
        salutation_id: '',
        suffix: '',
        notes: '',
        avatar_filename: '',
        city: '',
        country_id: '',
        address_line_1: '',
        province: '',
        address_line_2: '',
        postcode: '',
        user_role_id: '',
        user_role: {
          name: ''
        }
      },
      avatar:'',
      data_not_found: false,

      //reading docs
      tableRead: [],
      files: []
    }
  },
  computed: {
  },
  methods: {
    //reading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.view_data.email}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/user/delete/${viewId}`, {
              token: this.token
            })
            .then(res => {        
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
              } else {
                this.$router.push({name:'app-user-list'})
                this.showDeleteSuccess()
              }

            })
            .catch(err => {              
              reject(err)
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.data_local = res[0]
        })
      })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Data Deleted',
        text: 'The selected data was successfully deleted'
      })
    },
    async loadData () {
      this.$vs.loading()
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
            await axios.get(`/user/view/${viewId}`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-user-list'})
              } else {
                console.log('res d ', res['data'])
                resolve(res['data'][0])
              }

              // this.$vs.loading.close()
            })
            .catch(err => {
              this.data_not_found = true
              this.$vs.loading.close()
            })

            //reading docs
            this.tableRead = await axios.post(`/docs/table/read/`, {
              token: this.token,
              path: `docs/user/avatar/${viewId}`,
              document_folder_id: 3
            })

            //reading docs
            for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
              var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
              var imgAsc = imgB64.toString('ascii')
              this.files.push("data:image/png;base64, " + imgAsc)
            } 

            this.$vs.loading.close()           
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        // d.then((res) => {
        //   this.view_data = res[0]
        // })
      })

      this.view_data = await d
      this.$vs.loading.close()
    }
  },
  async created () {
    // crud
    this.showL = await mainHelper.cansee('user-list', 'list')
    this.showC = await mainHelper.cansee('user-create', 'create')
    this.showR = await mainHelper.cansee('user-read', 'read')
    this.showU = await mainHelper.cansee('user-update', 'update')
    this.showD = await mainHelper.cansee('user-delete', 'delete')

    this.access_level = await mainHelper.loadUserAccessLevel()

    if (!this.showR) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }

    this.loadData()
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-data-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

.avatar-img {
  position: relative;
  width: 230px;
  overflow: hidden;
  padding-top: 230px;
}

.avatar-img img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
}

</style>
